export const useTracking = () => {
  const sendEvent = (
    eventName: string,
    params: Gtag.EventParams | Gtag.CustomParams
  ) => {
    if (process.env.NODE_ENV !== "production") {
      console.log("Tracking event:", eventName, params);
      return;
    }

    window.gtag("event", eventName, params);
  };

  return {
    sendEvent,
  };
};
